import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Footer from "../common/Footer";
import moment from "moment";

const AdminDisputesPage = () => {
  const [disputes, setDisputes] = useState([]);
  const [profile, setProfile] = useState(localStorage.getItem("userRole") || "");
  const userToken = localStorage.getItem("userToken");

  useEffect(() => {
    fetchDisputes();
    fetchProfile();
  }, []);

  const fetchProfile = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/user`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        const profileType = response?.data?.user?.profileType;
        setProfile(profileType);
        if (profileType) {
          localStorage.setItem("userRole", profileType);
        }
      })
      .catch(() => {});
  };

  const fetchDisputes = async () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_LOCAL_API}/alldisputes`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setDisputes(response.data.data);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong! Please try again later.",
          confirmButtonColor: "#3ca151",
          icon: "error",
        });
      });
  };

  const handleStatusUpdate = async (id, newStatus) => {
    let data = JSON.stringify({ status: "resolved" });

    Swal.fire({
      title: "Are you sure this dispute is resolved ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      confirmButtonColor: "#3ca151",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        let config = {
          method: "patch",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_LOCAL_API}/dispute/${id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          data: data,
        };

        axios
          .request(config)
          .then((response) => {
            if (response?.data?.status) {
              Swal.fire({
                title: "Success!",
                text: "Status updated successfully!",
                confirmButtonColor: "#3ca151",
                icon: "success",
              });
              window.location.reload();
            }
          })
          .catch(() => {});
      }
    });
  };

  const sendMail = (recipient) => {
    const senderEmail = "mail@ie.money"; 
    const subject = encodeURIComponent("Inquiry from mail@ie.money");
    const body = encodeURIComponent("Dear recipient,\n\nThis is a prefilled email body.");
    
    const mailtoLink = `mailto:${recipient}?subject=${subject}&body=${body}`;
    
    window.location.href = mailtoLink;
  };

  return (
    <>
      <div style={{ width: "95%", margin: "50px auto", paddingBottom: "20px" }}>
        <h1 id="head_dash">Admin Support Page</h1>
        <div className="table">
          <table style={{ textAlign: "left" }}>
            <thead>
              <tr>
                <th style={{ width: "10%", textAlign: "left", whiteSpace: "nowrap" }}>Fullname</th>
                <th style={{ width: "10%", textAlign: "left", whiteSpace: "nowrap" }}>Email</th>
                <th style={{ width: "10%", textAlign: "left", whiteSpace: "nowrap" }}>Phone</th>
                <th style={{ width: "18%", textAlign: "left", whiteSpace: "nowrap" }}>Date</th>
                <th style={{ width: "10%", textAlign: "left", whiteSpace: "nowrap" }}>Transaction Id</th>
                <th style={{ width: "35%", textAlign: "left", whiteSpace: "nowrap" }}>Description</th>
                <th style={{ width: "10%", textAlign: "left", whiteSpace: "nowrap" }}>Status</th>
                {profile !== "view_access" && <th style={{ width: "10%", textAlign: "left", whiteSpace: "nowrap" }}>Action</th>}
              </tr>
            </thead>
            <tbody>
              {disputes?.map((dispute) => (
                <tr key={dispute._id}>
                  <td style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                    {dispute.firstName} {dispute.lastName}
                  </td>
                  <td className="send-email" style={{ textAlign: "left" }} onClick={()=>sendMail(dispute.email)}>{dispute.email}</td>
                  <td style={{ textAlign: "left" }}>{dispute.phone || "N/A"}</td>
                  <td style={{ whiteSpace: "nowrap", fontSize: "13px", textAlign: "left" }}>
                    {moment(dispute.createdDate).format("DD-MM-YYYY hh:mm A")}
                  </td>
                  <td style={{ textAlign: "left" }}>{dispute.transId || "N/A"}</td>
                  <td style={{ textAlign: "left" }}>
                    <strong>{dispute.title}</strong>
                    <br />
                    {dispute.description}
                  </td>
                  <td style={{ textAlign: "left" }}>{dispute.status}</td>
                  {profile !== "view_access" && (
                    <td style={{ textAlign: "left" }}>
                      {dispute.status === "pending" && (
                        <button onClick={() => handleStatusUpdate(dispute._id)}>
                          Mark as Resolved
                        </button>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default AdminDisputesPage;
